import { Stack, Box } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';

import { CardContent } from './CardContent/CardContent';
import { CardHeading } from './CardHeading/CardHeading';

type HeadingProps = ComponentProps<typeof CardHeading>;

export interface CardProps extends Omit<HeadingProps, 'subTitle' | 'title'> {
  emptyCardText?: string;
  isEmpty?: boolean;
  children: React.ReactNode;
  loader: React.ReactNode;
  cardAction?: JSX.Element | null;
  subTitle?: HeadingProps['subTitle'];
  title?: HeadingProps['title'];
}

export const Card = React.forwardRef(
  (
    {
      name,
      title,
      subTitle,
      emptyCardText,
      children,
      retryAction,
      topAction,
      cardAction = null,
      isEmpty,
      showNewBadge,
      showOptionalBadge,
      loading,
      loader,
    }: CardProps,
    ref: React.Ref<HTMLElement>,
  ) => {
    const headingProps: ComponentProps<typeof CardHeading> = {
      name,
      title,
      subTitle,
      retryAction,
      topAction,
      showNewBadge,
      showOptionalBadge,
      loading,
    };

    const loadingAction = loading ? <LoadingItem type="button" /> : cardAction;

    return (
      <Box
        data={{ automation: `${name}${loading ? '-loading' : ''}-card` }}
        component="section"
        {...(ref ? { ref } : {})}
      >
        <Stack space="large">
          {title ? <CardHeading {...headingProps} /> : null}

          <CardContent
            loading={loading}
            loader={loader}
            isEmpty={isEmpty}
            emptyCardText={emptyCardText}
            name={name}
          >
            {children}
          </CardContent>

          {cardAction ? loadingAction : null}
        </Stack>
      </Box>
    );
  },
);
